<template>
  <div class="animated fadeIn">
    <default-heading class="mt-3">Results</default-heading>
    <ResultServerTable />
  </div>
</template>

<script>
import DefaultHeading from '@/components/shared/DefaultHeading'
import ResultTable from '@/components/modus/result/ResultTable'
import ResultServerTable from '@/components/modus/result/ResultServerTable'

export default {
  name: 'ResultIndex',
  components: {
    ResultTable,
    DefaultHeading,
    ResultServerTable
  }
}
</script>
